import React, { useContext } from 'react';
import { DatePicker } from 'antd';
import { useTranslation } from 'react-i18next';
import { CustomFormat } from 'rc-picker/lib/interface';
import KeycloakContext from '@providers/Keycloak/KeycloakContext';
import moment, { Moment } from 'moment';
import { IObject } from '@utils/defaultTypes';

interface IParametrizedDatePickerProps {
  style?: IObject;
  size?: string;
  placeholder?: string;
  value?: Moment | null;
  defaultValue?: Moment[] | Moment | undefined;
  disabledDate?: (date: Moment) => boolean;
  onOpenChange?: (open: boolean) => void;
  allowClear?: boolean;
  onChange?: (date: Moment | null, dateString: string | string[]) => void;
  format?: string | CustomFormat<Moment> | Array<string | CustomFormat<Moment>>;
  hideFooter?: boolean;
  range?: boolean;
  ranges?: { [range: string]: Moment[] };
}

const { RangePicker } = DatePicker;

const ParametrizedDatePicker: React.FC<IParametrizedDatePickerProps> = ({
  value,
  allowClear,
  onChange,
  disabledDate,
  range,
  ...rest
}) => {
  const { i18n } = useTranslation();
  const { keycloak } = useContext(KeycloakContext);
  const { t: translate } = useTranslation('date-picker');

  const whichFormat = (locale: string) => {
    const localeDictionary = {
      pt: 'DD/MM/YYYY',
      es: 'DD/MM/YYYY',
      en: 'MM/DD/YYYY',
    };
    // @ts-ignore
    return localeDictionary[locale];
  };

  const config = {
    ...rest,
    onChange,
    value,
    disabledDate: disabledDate ?? (d => d && d > moment().endOf('day')),
    allowClear,
    format: whichFormat(
      i18n?.language ?? keycloak?.idTokenParsed?.locale ?? 'pt',
    ),
    placeholder: range
      ? [translate('initial-date'), translate('end-date')]
      : translate('initial-date'),
  };

  // @ts-ignore
  return range ? <RangePicker {...config} /> : <DatePicker {...config} />;
};

export default ParametrizedDatePicker;
